import type { TransitionMeasure } from "@/contexts/wizard/types";

/**
 * Groups a flat array of transition measures (as received from the API) by their
 * topicId, then invokes `setter` once per topic with that topic's measures.
 *
 * Shared across environment/social/governance slice hydration, which all store
 * transition measures keyed by topicId in reducer state but receive them as a
 * flat array from the API.
 */
export function groupTransitionMeasuresByTopic(
  measures: TransitionMeasure[],
  setter: (topicId: string, measures: TransitionMeasure[]) => void
): void {
  const byTopic = new Map<string, TransitionMeasure[]>();
  for (const m of measures) {
    const list = byTopic.get(m.topicId) || [];
    list.push(m);
    byTopic.set(m.topicId, list);
  }
  // .forEach() instead of for...of: this project's tsconfig has no downlevelIteration,
  // so iterating a Map with for...of fails to compile (TS2802).
  byTopic.forEach((topicMeasures, topicId) => {
    setter(topicId, topicMeasures);
  });
}
